import RepositoryService from 'src/services/repository'

const resource = 'partNumber'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  restore: idList => RepositoryService.crud.post(`${resource}/restore`, { idList }),
}
